import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
const { Text } = Typography;
const YesNoSelect = (props) => {
  const { text } = props;
  const value =
    text === true ? (
      <FormattedMessage id="app.forms.yes" />
    ) : text === false ? (
      <FormattedMessage id="app.forms.no" />
    ) : (
      ""
    );

  return <Text>{value}</Text>;
};

export default YesNoSelect;
